<template>
  <div class="lesson-menu-wrap">
    <transition name="menu-pop">
      <div v-if="lesson.showmenu" class="lesson-menu-panel" role="group" aria-label="Действия с занятием">
        <button
          class="menu-item"
          title="Заметки о предмете"
          aria-label="Заметки о предмете"
          @click="$emit('info-click')"
        ><img class="menu-ic" alt="Заметки" src="../../assets/info.svg" /><span class="menu-label">Заметки</span></button>
        <button
          class="menu-item"
          title="Расписание и замена кабинетов"
          aria-label="Расписание и замена кабинетов"
          @click="$emit('kab-click')"
        ><img class="menu-ic" alt="Кабинеты" src="../../assets/home.svg" /><span class="menu-label">Кабинет</span></button>
        <button
          class="menu-item"
          title="Расписание группы студентов"
          aria-label="Расписание группы студентов"
          @click="$emit('strasp-click')"
        ><img class="menu-ic" alt="Студенты" src="../../assets/student.svg" /><span class="menu-label">Студенты</span></button>
        <button
          v-if="lesson.groups && lesson.groups.length"
          class="menu-item"
          title="Журнал посещаемости и оценок группы по этому предмету"
          aria-label="Журнал посещаемости и оценок"
          @click="$emit('grades-click')"
        ><img class="menu-ic" alt="Оценки" src="../../assets/grades.svg" /><span class="menu-label">Оценки</span></button>
        <button
          class="menu-item"
          title="Настройки предмета для этой группы (подгруппы и др.)"
          aria-label="Настройки предмета"
          @click="$emit('settings-click')"
        ><img class="menu-ic" alt="Настройки" src="../../assets/gear.svg" /><span class="menu-label">Настройки</span></button>
        <button
          v-if="lesson.manual"
          class="menu-item"
          title="Редактировать занятие"
          aria-label="Редактировать занятие"
          @click="$emit('edit-click')"
        ><img class="menu-ic" alt="Редактировать" src="../../assets/edit.svg" /><span class="menu-label">Изменить</span></button>
        <button
          class="menu-item"
          title="Копировать или перенести занятие"
          aria-label="Копировать или перенести занятие"
          :id="`copylessonid_${id.idd}_${id.idl}`"
          @click="$emit('copy-click')"
        ><img class="menu-ic" alt="Копировать" src="../../assets/copy.svg" /><span class="menu-label">Копия</span></button>
        <button
          class="menu-item"
          title="Удалить занятие"
          aria-label="Удалить занятие"
          :id="`lessondelid_${id.idd}_${id.idl}`"
          @click="delClick"
        ><img class="menu-ic" alt="Удалить" src="../../assets/del.svg" /><span class="menu-label">Удалить</span></button>
        <button
          class="menu-item"
          title="Записать занятие в Журнал преподавателя"
          aria-label="Записать занятие в Журнал преподавателя"
          :id="`lessontoissid_${id.idd}_${id.idl}`"
          @click="$emit('work-click')"
        ><img class="menu-ic" alt="В журнал" src="../../assets/journal.svg" /><span class="menu-label">В журнал</span></button>
      </div>
    </transition>
    <button
      type="button"
      class="menu-toggle"
      :aria-expanded="!!lesson.showmenu"
      :aria-label="lesson.showmenu ? 'Скрыть меню занятия' : 'Показать меню занятия'"
      @click="$emit('close')"
    >{{ lesson.showmenu ? '»' : '«' }}</button>
  </div>
</template>

<script>
export default {
  name: 'lessonName',
  props: {
    lesson: Object,
    id: Object
  },
  methods: {
    delClick() {
      this.$emit('del-click')
    }
  }
}
</script>

<style>
.lesson-menu-wrap {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: flex-start;
  z-index: 20;
}

.menu-toggle {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  border: 1px solid var(--menu-border);
  background-color: var(--menu-bg);
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px var(--shadow);
  transition: background-color .2s ease, transform .15s ease;
}
.menu-toggle:hover {
  background-color: var(--item-hover);
}
.menu-toggle:active {
  transform: scale(.94);
}

.lesson-menu-panel {
  position: absolute;
  top: 0;
  right: calc(100% + 6px);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  padding: 8px;
  border-radius: 14px;
  border: 1px solid var(--menu-border);
  background-color: var(--menu-bg);
  box-shadow: 0 10px 30px var(--shadow), 0 2px 8px var(--shadow);
  width: max-content;
  min-width: 224px;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 68px;
  min-height: 60px;
  padding: 6px 8px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text);
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color .15s ease, transform .15s ease;
}
.menu-item:hover {
  background-color: var(--item-hover);
}
.menu-item:active {
  transform: scale(.96);
}
.menu-item[aria-label*="Удалить"]:hover {
  background-color: var(--danger);
  color: #fff;
}
.menu-ic {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
.menu-label {
  white-space: nowrap;
}

/* Появление панели: сдвиг + прозрачность */
.menu-pop-enter-active, .menu-pop-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}
.menu-pop-enter, .menu-pop-leave-to {
  opacity: 0;
  transform: translateX(8px);
}

@media (prefers-reduced-motion: reduce) {
  .menu-toggle, .menu-item, .menu-pop-enter-active, .menu-pop-leave-active {
    transition: none;
  }
}

@media (max-width: 768px) {
  .lesson-menu-panel {
    grid-template-columns: repeat(2, 1fr);
    width: max-content;
    min-width: 160px;
  }
}
</style>
